import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { isImageLike, isVideoLike } from '@tencent/docs-mime-types';
import { joinPathToFileUrl } from "../path-to-file-url";
/**
 * .filemeta.json 文件转换器
 * 1. 负责获取当前文档本地 .filemeta.json
 * 2. 建立映射 objKey: fileMeta
 * 3. 建立缓存
 */
var FileMetaTransformer = /*#__PURE__*/function () {
  function FileMetaTransformer() {
    _classCallCheck(this, FileMetaTransformer);
    _defineProperty(this, "fileMetaItemMap", new Map());
  }
  _createClass(FileMetaTransformer, [{
    key: "getFileMetaItem",
    value: function () {
      var _getFileMetaItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var fileMetaItem;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fileMetaItem = this.fileMetaItemMap.get(id); // 不存在，动态获取数据
              if (fileMetaItem) {
                _context.next = 8;
                break;
              }
              _context.t0 = this;
              _context.next = 5;
              return this.getFileMetaJSON();
            case 5:
              _context.t1 = _context.sent;
              _context.t0.fillFileMetaItemMap.call(_context.t0, _context.t1);
              fileMetaItem = this.fileMetaItemMap.get(id);
            case 8:
              return _context.abrupt("return", fileMetaItem);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFileMetaItem(_x) {
        return _getFileMetaItem.apply(this, arguments);
      }
      return getFileMetaItem;
    }() // 获取 filemeta.json 内容
  }, {
    key: "getFileMetaJSON",
    value: function () {
      var _getFileMetaJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var localDocsFilePath, localFileDir, replaceLocalFileDir, fileMetaPath, resp, fileMetaJSON;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 获取本地文档路径，
              // mac: localFilePath=/Users/JerryC/Workspace/tencent/本地预览技术调研/Office本地编辑文件/无标题表格.xlsx
              // win: C:\\test\\Drive-test\\Drive.xlsx
              localDocsFilePath = getLocalFilePath();
              if (localDocsFilePath) {
                _context2.next = 3;
                break;
              }
              throw new Error('localFilePath 不存在与 location.href 中，非本地编辑场景');
            case 3:
              _context2.next = 5;
              return joinPathToFileUrl([localDocsFilePath, '..']);
            case 5:
              localFileDir = _context2.sent;
              replaceLocalFileDir = localFileDir.replace(/^file/, 'attachment-preview');
              if (replaceLocalFileDir) {
                _context2.next = 9;
                break;
              }
              throw new Error("localFileDir \u8BA1\u7B97\u9519\u8BEF, localDocsFilePath: ".concat(localDocsFilePath));
            case 9:
              // filemeta.json 路径
              fileMetaPath = "".concat(replaceLocalFileDir, "/.meta/filemeta.json"); // 通过客户端特殊协议，获取 json 数据
              _context2.next = 12;
              return fetch(fileMetaPath);
            case 12:
              resp = _context2.sent;
              _context2.next = 15;
              return resp.json();
            case 15:
              fileMetaJSON = _context2.sent;
              return _context2.abrupt("return", fileMetaJSON);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getFileMetaJSON() {
        return _getFileMetaJSON.apply(this, arguments);
      }
      return getFileMetaJSON;
    }() // 建立映射
  }, {
    key: "fillFileMetaItemMap",
    value: function fillFileMetaItemMap(fileMetaJSON) {
      var _fileMetaJSON$data,
        _this = this;
      (_fileMetaJSON$data = fileMetaJSON.data) === null || _fileMetaJSON$data === void 0 ? void 0 : _fileMetaJSON$data.forEach(function (item) {
        _this.fileMetaItemMap.set(item.objKey, item);
      });
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new FileMetaTransformer();
      }
      return this.instance;
    }
  }]);
  return FileMetaTransformer;
}();
_defineProperty(FileMetaTransformer, "instance", null);
var fileMetaTransformer = FileMetaTransformer.getInstance();

/**
 * 客户端编码 location.search 的时候，使用的 application/x-www-form-urlencoded 格式的编码规则，会把空格转换成 + 号。
 * 所以不适用 RFC 3986 标准的 encodeURIComponent/decodeURIComponent，所以这里用 URLSearchParams get 会更适合。
 * @example
 * [mac]: localFilePath=/Users/JerryC/Workspace/tencent/本地预览技术调研/Office本地编辑文件/无标题表格.xlsx
 * [win]: C:\\test\\Drive-test\\Drive.xlsx
 */
var getLocalFilePath = function getLocalFilePath() {
  var _URLSearchParams$get, _window, _window$location, _window$location$sear;
  return (_URLSearchParams$get = new URLSearchParams((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$sear = _window$location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.slice(1)).get('localFilePath')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : '';
};

/**
 * .filemeta.json 数据结构：
 * ```json
 * {
 *   // 版本号
 *   "version": "0.0.1",
 *   "data": [{
 *       "filename": "附件/李克勤 - 开学礼.mp3",
 *       "objKey": "5f794bcbe8a14d589c504cf6e9a170af",
 *       // 由 drive/fileInfo，drive/query 的组合信息。
 *       "fileMeta": {...}
 *   }]
 * }
 * ```
 */

var getThumbnailUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(fileMetaItem) {
    var _fileMetaItem$fileMet, _fileMetaItem$fileMet2, _fileMetaItem$fileMet3;
    var mimeType, docsFilePath, fileRelativePath, fileAbsolutePath, thumbnailUrl, _fileMetaItem$fileMet4, _fileMetaItem$fileMet5, _fileAbsolutePath, _thumbnailUrl;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          mimeType = (_fileMetaItem$fileMet = (_fileMetaItem$fileMet2 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet2 === void 0 ? void 0 : (_fileMetaItem$fileMet3 = _fileMetaItem$fileMet2.fileInfo) === null || _fileMetaItem$fileMet3 === void 0 ? void 0 : _fileMetaItem$fileMet3.mimeType) !== null && _fileMetaItem$fileMet !== void 0 ? _fileMetaItem$fileMet : '';
          docsFilePath = getLocalFilePath(); // 图片类型直接取原图
          if (!isImageLike(mimeType)) {
            _context3.next = 10;
            break;
          }
          fileRelativePath = fileMetaItem.fileName;
          _context3.next = 6;
          return joinPathToFileUrl([docsFilePath, '../', fileRelativePath]);
        case 6:
          fileAbsolutePath = _context3.sent;
          thumbnailUrl = fileAbsolutePath.replace(/^file/, 'attachment-preview');
          console.log('@@ [previewURL]', thumbnailUrl);
          return _context3.abrupt("return", thumbnailUrl);
        case 10:
          if (!isVideoLike(mimeType)) {
            _context3.next = 17;
            break;
          }
          _context3.next = 13;
          return joinPathToFileUrl([docsFilePath, '../', (_fileMetaItem$fileMet4 = (_fileMetaItem$fileMet5 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet5 === void 0 ? void 0 : _fileMetaItem$fileMet5.thumbnailPath) !== null && _fileMetaItem$fileMet4 !== void 0 ? _fileMetaItem$fileMet4 : '']);
        case 13:
          _fileAbsolutePath = _context3.sent;
          _thumbnailUrl = _fileAbsolutePath.replace(/^file/, 'attachment-preview');
          console.log('@@ [thumbnailUrl]', _thumbnailUrl);
          return _context3.abrupt("return", _thumbnailUrl);
        case 17:
          return _context3.abrupt("return", null);
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getThumbnailUrl(_x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 本地的暂时拿的是只有附件的信息，所以只需要传 objkey 就行。
 */
export var getFileInfoFromLocal = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(req) {
    var fileMetaItem, thumbnailUrl;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (req.objKey) {
            _context4.next = 2;
            break;
          }
          throw new Error("Can not find objKey from req: ".concat(req));
        case 2:
          _context4.next = 4;
          return fileMetaTransformer.getFileMetaItem(req.objKey);
        case 4:
          fileMetaItem = _context4.sent;
          if (fileMetaItem !== null && fileMetaItem !== void 0 && fileMetaItem.fileMeta.fileInfo) {
            _context4.next = 7;
            break;
          }
          throw new Error("Can not find fileMetaItem from objKey: ".concat(req.objKey));
        case 7:
          _context4.next = 9;
          return getThumbnailUrlFromLocal(req.objKey);
        case 9:
          thumbnailUrl = _context4.sent;
          if (thumbnailUrl) {
            _context4.next = 12;
            break;
          }
          throw new Error("Can not find thumbnailUrls from objKey: ".concat(req.objKey));
        case 12:
          return _context4.abrupt("return", {
            data: {
              result: _objectSpread(_objectSpread({}, fileMetaItem.fileMeta.fileInfo), {}, {
                fileMeta: _objectSpread(_objectSpread({}, fileMetaItem.fileMeta.fileInfo.fileMeta), {}, {
                  thumbnailUrl: thumbnailUrl
                })
              }),
              retcode: 0,
              msg: 'ok'
            },
            status: 200,
            statusText: ''
          });
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getFileInfoFromLocal(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getThumbnailUrlFromLocal = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(objKey) {
    var fileMetaItem;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return fileMetaTransformer.getFileMetaItem(objKey);
        case 3:
          fileMetaItem = _context5.sent;
          if (fileMetaItem) {
            _context5.next = 6;
            break;
          }
          throw new Error("Can not get fileMetaItem from: ".concat(objKey));
        case 6:
          _context5.next = 8;
          return getThumbnailUrl(fileMetaItem);
        case 8:
          return _context5.abrupt("return", _context5.sent);
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          throw _context5.t0;
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  }));
  return function getThumbnailUrlFromLocal(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
//# sourceMappingURL=get-file-info-local.js.map